
<!-- Template -->
<template>
  <div class="flex h-full min-h-screen items-center justify-center">
    <div class="-mt-16 max-w-2xl p-4 sm:-mt-32">
      <div class="brand-heading inline-block bg-brand-500 p-1 px-3 text-lg uppercase text-white">
        Page not found
      </div>
      <div class="brand-heading mb-4 mt-2 text-4xl text-brand-500 xxxs:text-5xl xxs:text-6xl">
        Oops! Error 404
      </div>

      <div>
        <div class="brand-body text-lg text-gray-600 xs:text-xl">
          Sorry, we can't seem to find the page you are looking for. Please return to the homepage or submit a bug report if you think something is broken.
        </div>
        <div class="mt-4 xxs:inline-block">
          <div class="w-full xxs:flex">
            <PrimaryButton
              :padding="'px-3 py-2'"
              :text="'Back to home'"
              @click="backToHome"
            />
            <div v-if="nodeEnv !== 'cordova'">
              <SecondaryButton
                class="mt-4 xxs:ml-6 xxs:mt-0"
                :padding="'px-3 py-2'"
                :text="'Submit a bug report'"
                @click="submitBugReport"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import PrimaryButton from '@/app/shared/components/base/button/primaryButton.vue';
import SecondaryButton from '@/app/shared/components/base/button/secondaryButton.vue';

export default {

  components: {
    PrimaryButton,
    SecondaryButton,
  },


  data() {
    return {
      nodeEnv: '',
    };
  },

  mounted() {
    this.nodeEnv = process.env.NODE_ENV;
  },

  methods: {
    backToHome() {
      this.$router.push('/');
    },

    submitBugReport() {
      window.open('https://form.asana.com/?k=lI-mNFCMqYpcU0FLrhC3dQ&d=1163201844111955');
      this.$router.push('/');
    },
  },
};
</script>
